import { render, staticRenderFns } from "./TabsBar.vue?vue&type=template&id=4b5283e1&scoped=true"
import script from "./TabsBar.vue?vue&type=script&lang=js"
export * from "./TabsBar.vue?vue&type=script&lang=js"
import style0 from "./TabsBar.vue?vue&type=style&index=0&id=4b5283e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5283e1",
  null
  
)

export default component.exports